export default "__VITE_ASSET__CRTmEPS2__"